const STEPPER_STATUS = 'hideStepper';

export const setStepperStatus = (tenantId: string, stepperStatus: string): void =>
  localStorage.setItem(`${tenantId}.${STEPPER_STATUS}`, stepperStatus);
export const removeStepperStatus = (tenantId: string): void => localStorage.removeItem(`${tenantId}.${STEPPER_STATUS}`);
export const getStepperStatus = (tenantId: string): string | null =>
  localStorage.getItem(`${tenantId}.${STEPPER_STATUS}`);

const WIDGET_INSTRUCTION_STATUS = 'hideWidgetInstruction';

export const setWidgetInstructionStatus = (stepperStatus: string): void =>
  localStorage.setItem(WIDGET_INSTRUCTION_STATUS, stepperStatus);
export const removeWidgetInstructionStatus = (): void => localStorage.removeItem(WIDGET_INSTRUCTION_STATUS);
export const getWidgetInstructionStatus = (): string | null => localStorage.getItem(WIDGET_INSTRUCTION_STATUS);

const ONBOARDING_STATUS = 'onboardingPassed';

export const setOnboardingStatus = (onboardingStatus: string): void =>
  localStorage.setItem(ONBOARDING_STATUS, onboardingStatus);
export const removetOnboardingStatus = (): void => localStorage.removeItem(ONBOARDING_STATUS);
export const getOnboardingStatus = (): string | null => localStorage.getItem(ONBOARDING_STATUS);
